import "./polyfills.js";

import React from "react";
import ReactDom from "react-dom";
import { Provider } from "react-redux";
import configureStore from "./store/configureStore";
import "normalize.css";
import "./styles/main";
import App from "./components/App";
import { setAuthToken } from "./actions/authDrawer";
import { getUserData } from "./actions/user";
import { getLocalItem } from "./utils/localdb";

// This is a dirty hack that should be removed when we upgrade to React 16
import ReactUpdates from "react-dom/lib/ReactUpdates";
import { logBatchingStrategy } from "utils/logBatchingStrategy";
ReactUpdates.injection.injectBatchingStrategy(logBatchingStrategy);

if (typeof window !== "undefined") {
  const preloadedState = window.__PRELOADED_STATE__;
  delete window.__PRELOADED_STATE__;

  const store = configureStore(preloadedState);

  const token = getLocalItem("authToken");
  if (token) {
    store.dispatch(setAuthToken(token))
      .then(() => store.dispatch(getUserData()));
  }

  const render = () => {
    ReactDom.render(
      <Provider store={store}>
        <App />
      </Provider>
      , document.getElementById("app")
    );
  };

  if (module.hot) {
    module.hot.accept("./components/App", () => {
      render();
    });
  }

  render();
}



// WEBPACK FOOTER //
// ./src/browser.js